export default __webpack_public_path__ + "static/Vector_3-17aed2b2e1ff05dd86fcd20d4a682edd.svg";